import { convertSecondsToTimeString } from 'src/app/vehicles/components/content-panel-vehicles/helpers/convert-seconds-to-time-string';
import { Stop } from '../models/manager-content-vehicle-history-drawer.model';
import { COLOR_HISTORY } from '../static/color-elements.static';

let popupIdCounter = 0;

export interface PopupStop {
  latitude: number;
  longitude: number;
  duration?: number;
  startDate?: Date;
  endDate?: Date;
  reference?: string;
}

export const createPopupStop = (coords: PopupStop, tramaIndex: number = 1) => {
  popupIdCounter++;
  const id = `popup-stop-${popupIdCounter}`;
  const urlGoogleMaps = `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;
  const longitude = coords.longitude ? `${coords.longitude.toFixed(6)}°` : '0°';
  const latitude = coords.latitude ? `${coords.latitude.toFixed(6)}°` : '0°';
  const duration = coords.duration
    ? `${convertSecondsToTimeString(coords.duration, {
        shortFormat: false,
        showZeros: true,
      })}`
    : '00:00:00';
  const startDate = coords.startDate
    ? new Date(coords.startDate)
        .toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    : '00/00/0000 00:00:00';
  const endDate = coords.endDate
    ? new Date(coords.endDate)
        .toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    : '00/00/0000 00:00:00';

  // IDs únicos para cada botón
  const ids = {
    pos: `${id}-pos-stop`,
    duration: `${id}-duration-stop`,
    startDate: `${id}-startDate-stop`,
    endDate: `${id}-endDate-stop`,
    reference: `${id}-reference-stop`,
  };

  // Formatear el número de trama con ceros a la izquierda (5 dígitos)
  const stopNumber = tramaIndex.toString().padStart(5, '0');

  // Header tipo chip
  const header = `
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <div style="flex:1; display:flex; justify-content:center;">
        <span style="background:${COLOR_HISTORY.STOP_COLOR}11; color:${COLOR_HISTORY.STOP_COLOR}; font-weight:600; border-radius:12px; padding:4px 18px; font-size:13px; letter-spacing:1px; box-shadow:0 1px 4px #0001;">PARADA ${stopNumber}</span>
      </div>
    </div>
  `;

  const popup = `
    ${header}
    <div id="${id}" style="font-family: 'Inter', Arial, sans-serif; font-size: 13px; color: #222;">
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Referencia:</span>
          <span style="min-width: 170px; max-width: 170px;" id="${
            ids.reference
          }-content">
            ${
              // se utiliza varios puntos para recervar espacio para la direccion en caso sea muy grande
              coords.reference
                ? coords.reference
                : 'Buscando dirección ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ......'
            }
          </span>
          <span id="${
            ids.reference
          }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
          
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Posición:</span>
        <span id="${
          ids.pos
        }-content" style="min-width: 170px; color: #1976d2; text-decoration: underline; cursor: pointer;" onclick="window.open('${urlGoogleMaps}', '_blank')">${latitude}, ${longitude}</span>
        <span id="${
          ids.pos
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      ${
        startDate
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Fecha de inicio:</span>
          <span style="min-width: 170px;" id="${ids.startDate}-content">${startDate}</span>
          <span id="${ids.startDate}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        endDate
          ? `
        <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Fecha de fin:</span>
          <span style="min-width: 170px;" id="${ids.endDate}-content">${endDate}</span>
          <span id="${ids.endDate}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        duration
          ? `
        <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Duración:</span>
          <span style="min-width: 170px;" id="${ids.duration}-content">${duration}</span>
          <span id="${ids.duration}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
    </div>
  `;

  // Devuelve el HTML y los valores a copiar para el listener externo
  return {
    html: popup,
    ids,
    values: {
      pos: `${coords.latitude},${coords.longitude}`,
      startDate: startDate ?? '',
      endDate: endDate ?? '',
      duration: coords.duration?.toString() ?? '',
    },
  };
};

export function adaptStopToPopupStop(stop: Stop): PopupStop {
  return {
    latitude: stop.latitude,
    longitude: stop.longitude,
    duration: stop.duration_s,
    startDate: new Date(stop.start),
    endDate: new Date(stop.end),
    reference: stop.reference,
  };
}
